export default class EmailCampaignView
{
	name = null
	audience = null
	exclusions = []
	subject = null
	message = null
	
	recipients = {}

	createdOn = null
	countedOn = null
	testedOn = null
	sentOn = null
	
	get sent()
	{
		return !!this.sentOn
	}
	
	get counted()
	{
		return !!this.countedOn
	}

	get tested()
	{
		return !!this.testedOn
	}

	get totalBounces()
	{
		return Object.values(this.recipients).map(r => !!r.bouncedOn).reduce((p, c) => p + (c ? 1 : 0), 0);
	}

	get totalDeliveries()
	{
		return Object.values(this.recipients).map(r => !!r.deliveredOn).reduce((p, c) => p + (c ? 1 : 0), 0);
	}

	get totalComplaints()
	{
		return Object.values(this.recipients).map(r => !!r.complainedOn).reduce((p, c) => p + (c ? 1 : 0), 0);
	}

	get totalOpens()
	{
		return Object.values(this.recipients).map(r => r.opens.length > 0).reduce((p, c) => p + (c ? 1 : 0), 0);
	}

	get totalInteractions()
	{
		return Object.values(this.recipients).map(r => r.linkClicks.length > 0).reduce((p, c) => p + (c ? 1 : 0), 0);
	}

	get recipientCount()
	{
		return Object.values(this.recipients).length
	}

	get results()
	{
		return Object.entries(this.recipients).map(([key, value]) => {
			let result = JSON.parse(JSON.stringify(value));
			result.email = key;
			return result;
		});
	}

	setRecipients(recipients)
	{
		recipients.forEach(r => {
			let recipient = new EmailCampaignView.Recipient();
			recipient.userId = r.userId
			this.recipients[r.email] = recipient;
		})
	}

	getOpens()
	{
		let recipientEmails = Object.keys(this.recipients).filter(e => this.recipients[e].opens.length > 0);
	
		return recipientEmails.map(e => ({
			userEmail: e,
			userId: this.recipients[e].userId,
			userAgents: this.recipients[e].opens.map(lc => lc.userAgent).join('\n').trim(),
		}))
	}

	getLinkClicks(linkId)
	{
		return Object.values(this.recipients).map(r => r.linkClicks.filter(lc => lc.linkId == linkId).length).reduce((p, c) => p + c, 0)
	}

	getLinkInteractions(linkId)
	{
		let recipientEmails = Object.keys(this.recipients).filter(e => this.recipients[e].linkClicks.filter(lc => lc.linkId == linkId).length > 0);
	
		return recipientEmails.map(e => ({
			userEmail: e,
			userId: this.recipients[e].userId,
			userAgents: this.recipients[e].linkClicks.filter(lc => lc.linkId == linkId).map(lc => lc.userAgent).join('\n').trim(),
		}))
	}

	static Recipient = class
	{
		userId = null
		messageId = null
		deliveredOn =  null
		bouncedOn = null
		complainedOn = null
		openedUserAgent = null
		linkClicks = []
		opens =  []

		static LinkClick = class
		{
			linkId = null
			userAgent = null
			isBotTrap = null
			clickedOn = null
		}

		static Open = class
		{
			userAgent = null
			openedOn = null
		}
	}
}